import React from 'react';

import { css } from '@betterment/samba-styled-system/css';

import { GraphQLProvider } from '../../RetailApp/graphql';
import { IdempotencyProviderWithFeatureRegistry } from '../../RetailApp/graphql/idempotency/IdempotencyProviderWithFeatureRegistry';
import { urlBuilder } from '../../Shared/urlBuilder';
import useCapitalizeWindowEvents from '../hooks/useCapitalizeWindowEvents';
import useSerializedWindowEventMutationHandler from '../hooks/useSerializedWindowEventMutationHandler';

export interface CapitalizeWebviewContentProps {
  webviewUrl: string;
  internalRolloverRedirectPath: string;
}

export const CapitalizeWebviewContent: React.FC<CapitalizeWebviewContentProps> = ({
  webviewUrl,
  internalRolloverRedirectPath,
}) => {
  const processWindowEvent = useSerializedWindowEventMutationHandler();

  useCapitalizeWindowEvents({
    onPartnerInternalRolloverRedirect: () => {
      window.location.href = internalRolloverRedirectPath;
    },
    onError: event => {
      window.console.error('Capitalize webview error', event.onError);
    },
    onCreateRothDestinationNeeded: () => {
      window.location.href = urlBuilder.appAddGoalFlowsNew.absolute({ product_category: 'retirement' });
    },
    onCreateTradDestinationNeeded: () => {
      window.location.href = urlBuilder.appAddGoalFlowsNew.absolute({ product_category: 'retirement' });
    },
    onCapitalizeRolloverCreated: processWindowEvent,
    onCapitalizeRolloverCanceled: processWindowEvent,
  });

  return (
    <iframe
      className={css({
        width: '100%',
        height: '90vh',
        border: 'none',
      })}
      src={webviewUrl}
      title="Capitalize rollover webview"
    />
  );
};

const CapitalizeWebviewContentWithIdempotency: React.FC<CapitalizeWebviewContentProps> = props => {
  return (
    <GraphQLProvider>
      <IdempotencyProviderWithFeatureRegistry featureName="capitalizeRollovers">
        <CapitalizeWebviewContent {...props} />
      </IdempotencyProviderWithFeatureRegistry>
    </GraphQLProvider>
  );
};

export default CapitalizeWebviewContentWithIdempotency;
